import { render } from "./animauxVue.vue?vue&type=template&id=2ac1139f&scoped=true"
import script from "./animauxVue.vue?vue&type=script&lang=js"
export * from "./animauxVue.vue?vue&type=script&lang=js"

import "../assets/css/animauxnew.css?vue&type=style&index=0&id=2ac1139f&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac1139f"]])

export default __exports__